/* /remove-metadata — the page (2026-11-04 rebuild).
 *
 * The engine (public/js/metadata-scrub.js) knows bytes; this file knows the
 * person. Three zones, one state:
 *
 *   SETUP   what was found in the batch = what will be removed. One list with
 *           a checkbox and a count per group — the old page showed the same
 *           vocabulary twice (a «found» summary and a separate checkbox grid).
 *   FILES   one list for the whole life of the batch: «before» chips, then
 *           «after» chips once cleaned. There is no second result list.
 *   DOSSIER what ONE file tells a stranger, in words and real values (where,
 *           when, which phone and its serial, the hidden video), and next to
 *           each line whether it will go or stay under the current choice.
 *
 * Photos are read once at intake (inspect) and re-read at cleaning; the
 * bytes are not held between the two, so 500 phone photos do not sit in the
 * tab's memory. Videos are never read whole: the engine reads box headers and
 * `moov`, and the cleaned file is a Blob of slices of the original.
 *
 * Billing is per delivered FILE (begin() reserves, record() charges only
 * what produced a result). The built-in samples are ours and never billed.
 */
(function () {
'use strict';
var W = window, D = document;
var SLUG = 'remove-metadata';
var app = D.getElementById('rmApp');
if (!app) return;
var L = {};
try { var lj = D.getElementById('rmL'); if (lj) L = JSON.parse(lj.textContent || '{}') || {}; } catch (e) {}
function $(id) { return D.getElementById(id); }
var MS = function () { return W.MetaScrub || null; };

/* ── telemetry ─────────────────────────────────────────────────────────── */
function ae(f, extra) {
    try { if (W.__ae) W.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, extra || {})); } catch (e) {}
}
function aeErr(op, err, extra) {
    try {
        if (W.__aeCritical) W.__aeCritical('tool_error', Object.assign({
            slug: SLUG, op: op, msg: ((err && err.message) || String(err || '')).slice(0, 180),
        }, extra || {}));
    } catch (e) {}
}
function stage(n) { try { if (W.__stage) W.__stage(n); } catch (e) {} }
function toast(m, type) { if (W.__toast) W.__toast(m, type || 'info'); }

/* ── strings ───────────────────────────────────────────────────────────── */
function t(k, fb) {
    var v = L[k];
    if (v && typeof v === 'object') return v.other || v.many || v.one || fb || k;
    return v || fb || k;
}
var LOC = (function () { try { return W.__intlLocale ? W.__intlLocale() : (W.__LOCALE || 'en'); } catch (e) { return 'en'; } })();
var PR = null;
try { PR = new Intl.PluralRules(LOC); } catch (e) {}
// Number-aware: a string or a CLDR map {one, few, many, other}.
function tn(k, n, fb) {
    var v = L[k];
    if (!v) return fb || k;
    if (typeof v === 'string') return v;
    var cat = PR ? PR.select(n) : 'other';
    return v[cat] || v.other || v.many || v.one || fb || k;
}
function fill(s, map) {
    return String(s).replace(/:(\w+)/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
var NF1 = null;
try { NF1 = new Intl.NumberFormat(LOC, { maximumFractionDigits: 1 }); } catch (e) {}
function num(n, d) {
    if (d != null) { try { return new Intl.NumberFormat(LOC, { maximumFractionDigits: d }).format(n); } catch (e) { return n.toFixed(d); } }
    return NF1 ? NF1.format(n) : String(Math.round(n * 10) / 10);
}
function size(b) {
    if (b == null) return '';
    if (b < 1024) return b + ' ' + t('u_b', 'B');
    if (b < 1048576) return num(b / 1024) + ' ' + t('u_kb', 'KB');
    if (b < 1073741824) return num(b / 1048576) + ' ' + t('u_mb', 'MB');
    return num(b / 1073741824, 2) + ' ' + t('u_gb', 'GB');
}
function dur(s) {
    if (!s || !isFinite(s)) return '';
    s = Math.round(s);
    var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return (h ? h + ':' + (m < 10 ? '0' : '') : '') + m + ':' + (x < 10 ? '0' : '') + x;
}
function listJoin(arr) {
    try { return new Intl.ListFormat(LOC, { style: 'long', type: 'conjunction' }).format(arr); } catch (e) { return arr.join(', '); }
}
function svg(id) { return '<svg aria-hidden="true" focusable="false"><use href="#rmi-' + id + '"/></svg>'; }

/* ── the vocabulary ────────────────────────────────────────────────────── */
// Order = how much a stranger learns. Tone drives colour: a coordinate is a
// different kind of problem from a lens model, and the page should say so.
var ORDER = ['gps', 'hidden', 'serial', 'person', 'datetime', 'camera', 'thumbnail', 'c2pa', 'settings', 'copyright', 'other'];
var TONE = { gps: 'risk', hidden: 'risk', serial: 'risk', person: 'warn', datetime: 'warn', camera: 'warn',
             thumbnail: 'warn', c2pa: 'warn', settings: '', copyright: '', other: '', icc: '' };
var PRESETS = { full: 1, location: 1, share: 1, custom: 1 };

/* ── state ─────────────────────────────────────────────────────────────── */
var S = {
    items: [],          // {id, file, name, size, kind, format, report, sample, thumb, res}
    mode: 'full',
    custom: null,       // keep-map when mode === 'custom'
    gps: 'off',         // what replaces a removed location: off | district | city
    busy: false,
    done: false,
    sel: -1,
    seq: 0,
};
var MAX_ITEMS = 500;
var SAMPLE_KEYS = {};   // 'name|size' of our own example files

/* ── readers ───────────────────────────────────────────────────────────── */
function fileReader(f) {
    return {
        size: f.size,
        read: function (o, n) {
            return f.slice(o, Math.min(f.size, o + n)).arrayBuffer().then(function (b) { return new Uint8Array(b); });
        },
    };
}
function isVideoFmt(fmt) { var M = MS(); return !!(M && M.VIDEO_SUPPORTED && M.VIDEO_SUPPORTED[fmt]); }
function mimeOf(fmt) {
    return ({ jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', gif: 'image/gif', tiff: 'image/tiff',
              heic: 'image/heic', avif: 'image/avif', mp4: 'video/mp4', mov: 'video/quicktime' })[fmt] || 'application/octet-stream';
}
// Yield between files: scheduler.yield where it exists (Chrome 129+) keeps the
// page answering clicks; in a hidden tab the site's own tick (timers there are
// throttled to 1/s and then 1/min).
function yieldUI() {
    if (D.hidden && W.__yieldTick) return W.__yieldTick(0);
    if (W.scheduler && typeof W.scheduler.yield === 'function') return W.scheduler.yield();
    return new Promise(function (r) { setTimeout(r, 0); });
}

/* ══════════════════════════ INTAKE ══════════════════════════ */
var drop = $('rmDrop');
if (drop) {
    var onPick = function (f, d) {
        var files = (d && d.files && d.files.length) ? d.files : (f ? [f] : []);
        if (files.length) addFiles(Array.prototype.slice.call(files));
    };
    if (typeof W.__bindUploaderFile === 'function') W.__bindUploaderFile(drop, onPick);
    else drop.addEventListener('tool-uploader:file', function (e) { onPick(e.detail && e.detail.file, e.detail); });
}

var intakeQ = Promise.resolve();
function addFiles(files) {
    stage('file_select');
    intakeQ = intakeQ.then(function () { return intake(files); }).catch(function (err) { aeErr('intake', err); });
    return intakeQ;
}
function intake(files) {
    var M = MS();
    if (!M) { toast(t('err_engine', 'The cleaning engine failed to load. Please reload the page.'), 'error'); return Promise.resolve(); }
    var added = 0, skipped = 0, rejected = [], seen = {};
    S.items.forEach(function (it) { seen[it.name + '|' + it.size + '|' + (it.file.lastModified || 0)] = 1; });
    var i = 0;
    function next() {
        if (i >= files.length) return Promise.resolve();
        var f = files[i++];
        var key = f.name + '|' + f.size + '|' + (f.lastModified || 0);
        if (seen[key]) return next();          // the same file dropped twice
        if (S.items.length >= MAX_ITEMS) { skipped++; return next(); }
        seen[key] = 1;
        return f.slice(0, 64).arrayBuffer().then(function (hb) {
            var fmt = M.detect(new Uint8Array(hb));
            if (isVideoFmt(fmt)) {
                return M.inspectVideo(fileReader(f), f.name).then(function (rep) { push(f, 'video', fmt, rep); });
            }
            if (!M.SUPPORTED[fmt]) {
                skipped++;
                rejected.push(fmt === 'unknown' ? ((/\.([a-z0-9]+)$/i.exec(f.name) || [0, '?'])[1] || '?').toLowerCase() : fmt);
                return;
            }
            return f.arrayBuffer().then(function (buf) {
                var rep = M.inspect(new Uint8Array(buf), f.name);
                // The embedded thumbnail is shown in the dossier — the one
                // finding a person believes only once they see it.
                var th = M.thumbnailOf ? M.thumbnailOf(rep) : null;
                var it = push(f, 'image', fmt, rep);
                if (th && th.length > 100) {
                    try { it.exifThumb = URL.createObjectURL(new Blob([th], { type: 'image/jpeg' })); } catch (e) {}
                }
            });
        }).catch(function (err) {
            aeErr('read', err);
            skipped++;
        }).then(function () {
            if (i % 6 === 0) return yieldUI().then(next);
            return next();
        });
    }
    function push(f, kind, fmt, rep) {
        var it = {
            id: ++S.seq, file: f, name: f.name, size: f.size, kind: kind, format: fmt, report: rep,
            sample: !!SAMPLE_KEYS[f.name + '|' + f.size], thumb: null, res: null,
        };
        S.items.push(it);
        added++;
        return it;
    }
    return next().then(function () {
        if (skipped) toast(fill(tn('err_skipped', skipped, ':n file(s) skipped — unsupported format.'), { n: skipped }), 'warning');
        if (rejected.length) {
            try {
                if (W.__aeDiagnostic) W.__aeDiagnostic({ issue: 'unsupported_input', slug: SLUG, kinds: rejected.slice(0, 12).join(','), n: rejected.length });
            } catch (e) {}
        }
        if (!added) return;
        // A new file after a run starts a new batch decision: results are
        // stale the moment the list changes.
        if (S.done) leaveResult();
        if (S.sel < 0 || S.sel >= S.items.length) S.sel = firstWorthShowing();
        render(true);
        stage('ready');
        intakeTelemetry(added);
        precheck();
        if (gpsLevel() === 'city' && !currentKeep().gps) placeAll().then(renderDetail);
    });
}
function firstWorthShowing() {
    for (var i = 0; i < S.items.length; i++) {
        var c = S.items[i].report.classes;
        if (c.gps || c.serial || c.hidden || c.person) return i;
    }
    return S.items.length ? 0 : -1;
}
// Aggregated per intake, not per file: a 500-file batch must not emit 500
// rows — but we still need to know whether C2PA, Motion Photos and GPS
// tracks occur in the wild, since those are what this engine exists for.
function intakeTelemetry(added) {
    var agg = {}, fmts = {}, hidden = 0, gps = 0, video = 0;
    S.items.forEach(function (it) {
        fmts[it.format] = (fmts[it.format] || 0) + 1;
        Object.keys(it.report.classes).forEach(function (c) { agg[c] = (agg[c] || 0) + 1; });
        hidden += it.report.hiddenBytes || 0;
        if (it.report.gps) gps++;
        if (it.kind === 'video') video++;
    });
    ae('files_added', {
        n: added, total: S.items.length, fmt: Object.keys(fmts).sort().join(','),
        found: Object.keys(agg).sort().join(','), gps_n: gps, c2pa_n: agg.c2pa || 0,
        hidden_n: agg.hidden || 0, hidden_kb: Math.round(hidden / 1024), video_n: video,
        sample: S.items.some(function (x) { return x.sample; }) ? 1 : 0,
        mb: Math.round(S.items.reduce(function (a, x) { return a + x.size; }, 0) / 1048576),
    });
}
function realFiles(list) { return (list || S.items).filter(function (x) { return !x.sample; }).map(function (x) { return x.file; }); }
// Show the wall as soon as the QUEUE cannot be afforded, not only on press.
function precheck() {
    try { if (W.__toolLimit && W.__toolLimit.precheck) W.__toolLimit.precheck(SLUG, realFiles()); } catch (e) {}
}

/* ── built-in example ─────────────────────────────────────────────────── */
var sampleBtn = $('rmSample');
if (sampleBtn) sampleBtn.addEventListener('click', function () {
    sampleBtn.disabled = true;
    var base = (sampleBtn.getAttribute('data-base') || '/samples/remove-metadata/');
    var names = ['sample-photo.jpg', 'sample-video.mp4'];
    Promise.all(names.map(function (n) {
        return fetch(base + n, { cache: 'force-cache' }).then(function (r) {
            if (!r.ok) throw new Error('sample ' + r.status);
            return r.blob();
        }).then(function (b) {
            var f = new File([b], n, { type: b.type || (n.slice(-3) === 'mp4' ? 'video/mp4' : 'image/jpeg'), lastModified: 1747500129000 });
            SAMPLE_KEYS[n + '|' + f.size] = 1;
            return f;
        });
    })).then(function (files) {
        ae('sample_used');
        if (drop && typeof drop.__uploaderInjectFile === 'function') {
            files.forEach(function (f) { drop.__uploaderInjectFile(f, 'sample'); });
        } else addFiles(files);
    }).catch(function (err) {
        aeErr('sample', err);
        toast(t('err_sample', 'Could not load the example.'), 'error');
    }).then(function () { sampleBtn.disabled = false; });
});

/* ══════════════════════════ KEEP MAP ══════════════════════════ */
function presetKeep(m) {
    var M = MS();
    var k = M ? M.presetKeep(m === 'custom' ? 'full' : m) : {};
    return k;
}
function currentKeep() {
    var keep = S.mode === 'custom' && S.custom ? Object.assign({}, S.custom) : presetKeep(S.mode);
    var icc = $('rmKeepIcc');
    keep.icc = icc ? !!icc.checked : true;
    return keep;
}
/* ── «keep the place, not the spot» (04.11.2026) ───────────────────────────
 * off      — the location goes (the default);
 * district — a ~1 km grid cell (0.01°);
 * city     — the centre of the city around it (GeoCity: the site's cities
 *            set, the name in the reader's language); a ~10 km cell (0.1°)
 *            where no city is within CITY_KM.
 * A grid, not a random jitter: a dozen photos from one doorstep would
 * average a jitter back to the doorstep; a cell gives them one answer.
 * The question that leaves the page for the city is a ~2 km cell (0.02°),
 * never the photo's own point. Measured 04.11 on 800 spots within 8 km of
 * cities of our set: the cell names the same city as the exact point in
 * 96.1 % (0.01° — 97.5 %, 0.05° — 88.4 %: the Eiffel Tower became Vanves). */
var GPS_LEVELS = { off: 1, district: 1, city: 1 };
var CITY_KM = 40, geoP = null;
function gpsLevel() { return GPS_LEVELS[S.gps] ? S.gps : 'off'; }
function grid(x, step) { var v = Math.round(x / step) * step; return Math.round(v * 1e6) / 1e6 || 0; }
function cellOf(g, step, digits) { return { lat: grid(g.lat, step), lon: grid(g.lon, step), digits: digits }; }
function approxFor(it, keep) {
    var g = it.report && it.report.gps, lv = gpsLevel();
    if (!g || lv === 'off' || (keep || currentKeep()).gps) return null;
    if (lv === 'district') { var c = cellOf(g, 0.01, 2); c.kind = 'district'; return c; }
    return it.place || null;            // city: filled by placeAll()
}
function ensureGeoCity() {
    if (W.GeoCity) return Promise.resolve();
    if (geoP) return geoP;
    var a = ($('rmClasses') || {}).dataset || {};
    var vs = W.__vendorScript;
    if (typeof vs !== 'function' || !a.geoJs) return Promise.reject(new Error('no geo loader'));
    geoP = vs([a.geoJs, a.geoJsFb], { expect: 'GeoCity', label: 'geo-city' }).catch(function (e) { geoP = null; throw e; });
    return geoP;
}
function cityPoint(c, g) {
    if (c && c.found && c.at && c.km <= CITY_KM) {
        return { lat: +c.at[0], lon: +c.at[1], digits: 4, kind: 'city',
                 name: (W.GeoCity && W.GeoCity.text(c, { country: true })) || c.name };
    }
    var p = cellOf(g, 0.1, 1);
    p.kind = 'area';
    p.soft = !c;             // no answer at all (network): ask again next time
    return p;
}
function placeAll() {
    var todo = S.items.filter(function (it) { return it.report && it.report.gps && (!it.place || it.place.soft); });
    if (!todo.length) return Promise.resolve();
    return ensureGeoCity().then(function () {
        return Promise.all(todo.map(function (it) {
            var g = it.report.gps, q = cellOf(g, 0.02, 2);
            return W.GeoCity.lookup(q.lat, q.lon, { mode: 'near' }).then(function (c) { it.place = cityPoint(c, g); });
        }));
    }, function (err) {
        aeErr('geo_city', err);
        todo.forEach(function (it) { it.place = cityPoint(null, it.report.gps); });
    });
}
function setGpsLevel(v) {
    S.gps = GPS_LEVELS[v] ? v : 'off';
    try { if (W.__toolSettings) W.__toolSettings.save(SLUG, 'gpsLevel', S.gps); } catch (e) {}
    ae('gps_level', { v: S.gps });
    renderDetail();
    if (S.gps === 'city') placeAll().then(renderDetail);
}
function gpsLevelRow(disabled) {
    var lv = gpsLevel();
    function opt(v, label) {
        return '<label class="rm-gl-o"><input type="radio" name="rmGps" value="' + v + '"' + (lv === v ? ' checked' : '') +
            (disabled ? ' disabled' : '') + '><span>' + esc(label) + '</span></label>';
    }
    return '<li class="rm-gl"><span class="rm-gl-t" id="rmGlT">' + esc(t('gps_leave', 'Instead of the point, keep')) + '</span>' +
        '<span class="rm-gl-g" role="radiogroup" aria-labelledby="rmGlT">' +
        opt('off', t('gps_off', 'nothing')) + opt('district', t('gps_district', 'district ≈1 km')) + opt('city', t('gps_city', 'city')) +
        '</span></li>';
}
// What the file will say (before) or says (after) instead of the point.
function placeText(ap) {
    if (!ap) return t('gps_p_wait', 'looking up the nearest city…');
    if (ap.kind === 'city') return fill(t('gps_p_city', ':name, city centre'), { name: ap.name });
    var s = ap.lat.toFixed(ap.digits) + ', ' + ap.lon.toFixed(ap.digits);
    if (ap.kind === 'area') return fill(t('gps_p_nocity', ':ll · no city nearby, accurate to ≈10 km'), { ll: s });
    return fill(t('gps_p_cell', ':ll · accurate to ≈1 km'), { ll: s });
}
function approxLine(it) {
    if (it.res) {
        if (!it.res.report.gpsApprox || !it.res.ap) return '';
        return '<span class="rm-gl-now">' + esc(fill(t('gps_now', 'Now in the file: :place'), { place: placeText(it.res.ap) })) + '</span>';
    }
    if (gpsLevel() === 'off' || currentKeep().gps || !it.report.gps) return '';
    return '<span class="rm-gl-now">' + esc(fill(t('gps_will', 'Will stay: :place'), { place: placeText(approxFor(it)) })) + '</span>';
}
/* The self-check for a rounded location: the file must carry exactly the
 * chosen point, with no altitude, and every location record in it must say
 * the same point (an iPhone clip has two or three of them). */
function approxHolds(v, ap) {
    var near = function (a, b) { return Math.abs(a - b) <= 2e-4; };
    if (!v.gps || !near(v.gps.lat, ap.lat) || !near(v.gps.lon, ap.lon) || v.gps.alt != null) return false;
    return (v.findings || []).every(function (f) {
        if (f.cls !== 'gps') return true;
        var n = String(f.detail || '').match(/[+-]?[0-9]+(?:[.][0-9]+)?/g);
        return !!n && n.length >= 2 && near(+n[0], ap.lat) && near(+n[1], ap.lon);
    });
}

function setMode(m, silent) {
    if (!PRESETS[m]) m = 'full';
    if (m === 'custom' && !S.custom) S.custom = presetKeep(S.mode === 'custom' ? 'full' : S.mode);
    S.mode = m;
    D.querySelectorAll('#rmModes .rm-mode').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-mode') === m ? 'true' : 'false');
        b.tabIndex = b.getAttribute('data-mode') === m ? 0 : -1;
    });
    var d = $('rmModeD');
    if (d) d.textContent = t('mode_' + m + '_d', '');
    if (!silent) {
        try { if (W.__toolSettings) W.__toolSettings.save(SLUG, 'mode', m); } catch (e) {}
        ae('mode', { mode: m });
    }
    renderClasses();
    renderDetail();
}
var modes = $('rmModes');
if (modes) {
    modes.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.rm-mode');
        if (b && !S.busy) setMode(b.getAttribute('data-mode'));
    });
    // A radiogroup moves with the arrows, the way the old hidden radios did.
    modes.addEventListener('keydown', function (e) {
        if (W.__keyOwnedByFocus && W.__keyOwnedByFocus(e)) return;
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        var step = keys[e.key];
        if (!step) return;
        var bs = Array.prototype.slice.call(modes.querySelectorAll('.rm-mode'));
        var i = bs.indexOf(D.activeElement);
        if (i < 0) return;
        if (D.documentElement.dir === 'rtl' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) step = -step;
        var n = bs[(i + step + bs.length) % bs.length];
        e.preventDefault();
        n.focus();
        setMode(n.getAttribute('data-mode'));
    });
}
var clsList = $('rmClasses');
if (clsList) clsList.addEventListener('change', function (e) {
    var cb = e.target;
    if (cb && cb.name === 'rmGps') { setGpsLevel(cb.value); return; }
    if (!cb || !cb.hasAttribute('data-cls')) return;
    // Touching a group is customising: start from what the preset meant.
    if (S.mode !== 'custom') { S.custom = presetKeep(S.mode); setMode('custom', true); }
    S.custom[cb.getAttribute('data-cls')] = !cb.checked;     // checked = remove
    try {
        if (W.__toolSettings) {
            W.__toolSettings.save(SLUG, 'mode', 'custom');
            W.__toolSettings.save(SLUG, 'custom', JSON.stringify(S.custom));
        }
    } catch (x) {}
    renderClasses();
    renderDetail();
});
['rmKeepIcc', 'rmKeepOri', 'rmKeepHdr', 'rmRename'].forEach(function (id) {
    var el = $(id);
    if (el) el.addEventListener('change', function () { renderKeepSub(); renderDetail(); });
});

/* ══════════════════════════ RENDER ══════════════════════════ */
function render(fresh) {
    var has = S.items.length > 0;
    var work = $('rmWork');
    var swap = function () {
        app.setAttribute('data-state', !has ? 'empty' : S.done ? 'done' : 'ready');
        if (work) {
            work.hidden = !has;
            work.classList.toggle('is-single', S.items.length === 1);
        }
        $('rmSetup').hidden = S.done;
        $('rmResult').hidden = !S.done;
        if (!has) return;
        renderCount();
        renderClasses();
        renderKeepSub();
        renderList();
        renderDetail();
        renderMapBtn();
        if (batchMap && !$('rmMapWrap').hidden) drawBatch();
        if (S.done) renderResult();
        layout();
    };
    if (fresh && W.__viewTransition) W.__viewTransition(swap); else swap();
}
function renderCount() {
    var n = S.items.length, bytes = S.items.reduce(function (a, x) { return a + x.size; }, 0);
    var line = fill(tn('total_line', n, ':n file(s) · :size'), { n: n, size: size(bytes) });
    $('rmTotal').textContent = line;
    var run = $('rmRunBtn');
    if (run && !S.busy) run.textContent = n === 1 ? t('run_one', 'Clean and check') : fill(tn('run_n', n, 'Clean :n files'), { n: n });
}
function counts() {
    var c = {};
    S.items.forEach(function (it) { ORDER.forEach(function (k) { if (it.report.classes[k]) c[k] = (c[k] || 0) + 1; }); });
    return c;
}
function renderClasses() {
    var ul = $('rmClasses');
    if (!ul) return;
    var keep = currentKeep(), c = counts(), single = S.items.length === 1, rows = [], absent = [];
    ORDER.forEach(function (k) {
        if (!c[k]) { absent.push(t('c_' + k, k)); return; }
        rows.push('<li><label class="rm-c" data-tone="' + TONE[k] + '">' +
            '<input type="checkbox" data-cls="' + k + '"' + (keep[k] ? '' : ' checked') + (S.busy || S.done ? ' disabled' : '') + '>' +
            svg(k) + '<span class="rm-c-l">' + esc(t('c_' + k, k)) + '</span>' +
            '<span class="rm-c-n" data-keep="' + esc(t('st_keep', 'keep')) + '">' + (single ? '' : c[k]) + '</span>' +
            '</label></li>');
        if (k === 'gps' && !keep.gps) rows.push(gpsLevelRow(S.busy || S.done));
    });
    ul.innerHTML = rows.join('');
    var ab = $('rmAbsent');
    if (ab) {
        ab.textContent = !rows.length ? t('found_none', 'No metadata found — nothing to remove.')
            : absent.length ? fill(t('absent', 'Also checked, not found: :list.'), { list: listJoin(absent.map(inSentence)) }) : '';
    }
}
// «Встроенная миниатюра» → «встроенная миниатюра», but «C2PA / Content Credentials» stays.
// German capitalises every noun: «Standort» stays «Standort» mid-sentence.
function inSentence(s) {
    s = String(s);
    if (/^de\b/.test(LOC)) return s;
    return s.length > 1 && s[1] === s[1].toLowerCase() && s[1] !== s[1].toUpperCase() ? s[0].toLowerCase() + s.slice(1) : s;
}
function renderKeepSub() {
    var on = [];
    if ($('rmKeepIcc') && $('rmKeepIcc').checked) on.push(t('k_icc', 'colour'));
    if ($('rmKeepOri') && $('rmKeepOri').checked) on.push(t('k_ori', 'rotation'));
    if ($('rmKeepHdr') && $('rmKeepHdr').checked) on.push(t('k_hdr', 'HDR'));
    if ($('rmRename') && $('rmRename').checked) on.push(t('k_rename', 'new names'));
    var s = $('rmKeepSub');
    if (s) s.textContent = on.join(' · ');
}

/* ── file list ──────────────────────────────────────────────────────────── */
function fmtLabel(it) {
    var f = String(it.format).toUpperCase();
    var ext = ((/\.([a-z0-9]+)$/i.exec(it.name) || [0, ''])[1] || '').toUpperCase();
    // Name what we DETECTED, but stay recognisable: an .heic that is really
    // AV1-in-HEIF is still «the HEIC off my phone».
    if (!ext || ext === f) return f;
    if ((f === 'JPEG' && ext === 'JPG') || (f === 'TIFF' && ext === 'TIF')) return f;
    if ((f === 'HEIC' || f === 'AVIF') && (ext === 'HEIC' || ext === 'HEIF')) return ext;
    if ((f === 'MP4' || f === 'MOV') && /^(M4V|3GP|3G2|MP4|MOV|QT)$/.test(ext)) return ext;
    return f;
}
function sub(it) {
    var parts = [fmtLabel(it)];
    if (it.res) parts.push(size(it.res.report.sizeIn) + ' → ' + size(it.res.size));
    else parts.push(size(it.size));
    if (it.kind === 'video' && it.report.video && it.report.video.duration) parts.push(dur(it.report.video.duration));
    return parts.join(' · ');
}
function flags(it) {
    if (it.res) {
        return it.res.clean
            ? '<span class="rm-flag" data-tone="ok">' + svg('check') + esc(t('flag_done', 'cleaned')) + '</span>'
            : '<span class="rm-flag" data-tone="risk">' + svg('bad') + esc(t('flag_left', 'not everything')) + '</span>';
    }
    var cls = ORDER.filter(function (k) { return it.report.classes[k]; });
    var out = [];
    if (it.report.damaged) out.push('<span class="rm-flag" data-tone="warn">' + esc(t('file_damaged', 'damaged')) + '</span>');
    if (!cls.length) return out.join('') + '<span class="rm-flag" data-tone="ok">' + esc(t('flag_clean', 'nothing to remove')) + '</span>';
    cls.slice(0, 5).forEach(function (k) {
        out.push('<span class="rm-flag" data-tone="' + (TONE[k] || '') + '" title="' + esc(t('c_' + k, k)) + '">' + svg(k) + '</span>');
    });
    if (cls.length > 5) out.push('<span class="rm-flag">+' + (cls.length - 5) + '</span>');
    return out.join('');
}
function thumbHtml(it) {
    var inner = it.thumb ? '<img alt="" src="' + it.thumb + '">' : esc(fmtLabel(it));
    return '<span class="rm-th" data-th="' + it.id + '">' + inner +
        (it.kind === 'video' ? '<span class="rm-vid">' + svg('play') + '</span>' : '') + '</span>';
}
function renderList() {
    var list = $('rmFiles');
    if (!list) return;
    var det = $('rmDetail');
    if (det && det.parentNode === list) $('rmWork').appendChild(det);   // keep the dossier out of the rewrite
    list.innerHTML = S.items.map(function (it, i) {
        return '<button type="button" class="rm-card" role="option" data-i="' + i + '" aria-selected="' + (i === S.sel ? 'true' : 'false') + '"' +
            ' tabindex="' + (i === S.sel || (S.sel < 0 && i === 0) ? 0 : -1) + '">' +
            thumbHtml(it) +
            '<span class="rm-cm"><span class="rm-cn" dir="auto">' + esc(it.res ? it.res.outName : it.name) + '</span>' +
            '<span class="rm-cs">' + esc(sub(it)) + '</span>' +
            '<span class="rm-flags">' + flags(it) + '</span></span></button>';
    }).join('');
    paintThumbs();
}
if ($('rmFiles')) {
    $('rmFiles').addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.rm-detail')) return;
        var card = e.target.closest && e.target.closest('.rm-card');
        if (!card) return;
        var i = parseInt(card.getAttribute('data-i'), 10);
        select(i === S.sel && !wideLayout() ? -1 : i, true);
    });
    $('rmFiles').addEventListener('keydown', function (e) {
        if (e.target.closest && e.target.closest('.rm-detail')) return;
        if (W.__keyOwnedByFocus && !(e.target.closest && e.target.closest('.rm-card')) && W.__keyOwnedByFocus(e)) return;
        var step = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!step || !S.items.length) return;
        e.preventDefault();
        var i = Math.max(0, Math.min(S.items.length - 1, (S.sel < 0 ? 0 : S.sel) + step));
        select(i, true);
        var c = $('rmFiles').querySelector('.rm-card[data-i="' + i + '"]');
        if (c) c.focus();
    });
}
function select(i, user) {
    S.sel = i;
    D.querySelectorAll('#rmFiles .rm-card').forEach(function (c) {
        var on = parseInt(c.getAttribute('data-i'), 10) === i;
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
    });
    renderDetail();
    placeDetail();
    if (user) {
        ae('detail_open');
        var det = $('rmDetail');
        if (det && !det.hidden && !wideLayout()) { try { det.scrollIntoView({ block: 'nearest' }); } catch (e) {} }
    }
}

/* Thumbnails, cheapest source first, one at a time (a phone tab dies on 40
 * full-size decodes at once): createImageBitmap at 112 px for stills, the
 * first frame for clips. Past THUMB_LIMIT the format badge is enough. */
var THUMB_LIMIT = 80, VIDEO_THUMB_LIMIT = 16;
var thumbQ = [], thumbBusy = false;
function paintThumbs() {
    thumbQ = [];
    var vids = 0;
    S.items.forEach(function (it, i) {
        if (it.thumb || it.noThumb) return;
        if (i >= THUMB_LIMIT) return;
        if (it.kind === 'video' && ++vids > VIDEO_THUMB_LIMIT) return;
        thumbQ.push(it);
    });
    if (!thumbBusy) nextThumb();
}
function nextThumb() {
    var it = thumbQ.shift();
    if (!it) { thumbBusy = false; return; }
    thumbBusy = true;
    (it.kind === 'video' ? videoThumb(it.file) : imageThumb(it)).then(function (url) {
        if (url) {
            it.thumb = url;
            D.querySelectorAll('[data-th="' + it.id + '"]').forEach(function (el) {
                var img = D.createElement('img');
                img.alt = ''; img.src = url;
                var vid = el.querySelector('.rm-vid');
                el.textContent = '';
                el.appendChild(img);
                if (vid) el.appendChild(vid);
            });
        } else it.noThumb = true;
    }).catch(function () { it.noThumb = true; }).then(function () {
        // Idle time, but not forever: a busy page has none to spare.
        if (W.requestIdleCallback) W.requestIdleCallback(nextThumb, { timeout: 250 });
        else setTimeout(nextThumb, 16);
    });
}
function imageThumb(it) {
    if (typeof createImageBitmap !== 'function') return Promise.resolve(it.exifThumb || null);
    return createImageBitmap(it.file, { resizeWidth: 112, resizeQuality: 'low' }).then(function (bmp) {
        var c = D.createElement('canvas');
        c.width = bmp.width; c.height = bmp.height;
        c.getContext('2d').drawImage(bmp, 0, 0);
        if (bmp.close) bmp.close();
        return c.toDataURL('image/jpeg', 0.7);
    }).catch(function () {
        // HEIC off Safari: the browser cannot draw it — the EXIF thumbnail,
        // if the camera wrote one, still can; iPhone HEIC has none, so the
        // site's own libheif worker (HeicDecode, loaded by the layout) decodes
        // a preview. ~2 s per 12 MP photo in a worker: a handful only.
        if (it.exifThumb) return it.exifThumb;
        if ((it.format === 'heic' || it.format === 'avif') && W.HeicDecode && heicThumbs < HEIC_THUMB_LIMIT) {
            heicThumbs++;
            return W.HeicDecode.toBlob(it.file, 'image/jpeg', 0.6).then(function (jpg) {
                return createImageBitmap(jpg, { resizeWidth: 112, resizeQuality: 'low' });
            }).then(function (bmp) {
                var c = D.createElement('canvas');
                c.width = bmp.width; c.height = bmp.height;
                c.getContext('2d').drawImage(bmp, 0, 0);
                if (bmp.close) bmp.close();
                return c.toDataURL('image/jpeg', 0.7);
            }).catch(function () { return null; });
        }
        return null;
    });
}
var HEIC_THUMB_LIMIT = 12, heicThumbs = 0;
function videoThumb(file) {
    return new Promise(function (resolve) {
        var v = D.createElement('video'), url = null, done = false;
        function fin(u) {
            if (done) return;
            done = true;
            try { v.removeAttribute('src'); v.load(); } catch (e) {}
            try { if (url) URL.revokeObjectURL(url); } catch (e) {}
            resolve(u);
        }
        var later = W.__visibleTimeout || setTimeout;
        later(function () { fin(null); }, 6000);
        v.muted = true; v.playsInline = true; v.preload = 'auto';
        v.addEventListener('error', function () { fin(null); });
        v.addEventListener('loadeddata', function () {
            var at = Math.min(0.4, (isFinite(v.duration) && v.duration > 0 ? v.duration : 1) / 3);
            var draw = function () {
                try {
                    if (!v.videoWidth) return fin(null);
                    var k = 112 / Math.max(v.videoWidth, v.videoHeight);
                    var c = D.createElement('canvas');
                    c.width = Math.max(1, Math.round(v.videoWidth * k));
                    c.height = Math.max(1, Math.round(v.videoHeight * k));
                    c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
                    fin(c.toDataURL('image/jpeg', 0.7));
                } catch (e) { fin(null); }
            };
            if (typeof W.__seekPresented === 'function') W.__seekPresented(v, at, 2500).then(draw, draw);
            else { v.addEventListener('seeked', draw, { once: true }); v.currentTime = at; }
        });
        try { url = URL.createObjectURL(file); v.src = url; } catch (e) { fin(null); }
    });
}

/* ── the dossier ───────────────────────────────────────────────────────── */
function findings(it, cls) { return (it.report.findings || []).filter(function (f) { return f.cls === cls; }); }
function first(arr, labels) {
    for (var i = 0; i < labels.length; i++) {
        for (var j = 0; j < arr.length; j++) if (arr[j].label === labels[i] && arr[j].detail) return arr[j].detail;
    }
    return '';
}
/* The wall clock AS WRITTEN, with the zone it was written in. A photo's EXIF
 * time is the camera's local time and a video header's time is UTC; turning
 * either into the viewer's zone showed an hour that never happened where the
 * picture was taken («18 мая, 02:12» for a clip shot at 16:42 UTC). */
function fmtDate(s) {
    if (!s) return '';
    var m = /^(\d{4})[:\-](\d\d)[:\-](\d\d)[ T](\d\d):(\d\d)(?::(\d\d))?(?:\.\d+)?\s*(Z|[+-]\d\d:?\d\d)?$/.exec(String(s).trim());
    if (!m) return s;
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)));
    if (isNaN(d.getTime())) return s;
    var out;
    try { out = new Intl.DateTimeFormat(LOC, { dateStyle: 'long', timeStyle: 'short', timeZone: 'UTC' }).format(d); }
    catch (e) { out = d.toISOString().slice(0, 16).replace('T', ' '); }
    if (m[7] === 'Z') out += ' UTC';
    else if (m[7]) out += ' (UTC' + m[7].replace(/^([+-]\d\d):?(\d\d)$/, '$1:$2') + ')';
    return out;
}
function mapLink(g) {
    var la = g.lat.toFixed(6), lo = g.lon.toFixed(6);
    // Yandex for the Russian half, OpenStreetMap elsewhere — both open in a new tab.
    var href = (W.__LOCALE === 'ru')
        ? 'https://yandex.ru/maps/?pt=' + lo + ',' + la + '&z=16&l=map'
        : 'https://www.openstreetmap.org/?mlat=' + la + '&mlon=' + lo + '#map=16/' + la + '/' + lo;
    return '<a href="' + href + '" target="_blank" rel="noopener nofollow">' + esc(t('map_open', 'Open on a map')) + '</a>';
}
/* ── maps: Leaflet + the site's basemap primitive, loaded on the first press ── */
var mapBtn = $('rmMapBtn'), leafletP = null, batchMap = null, batchLayer = null;
function ensureLeaflet() {
    if (W.L && W.__mapTiles) return Promise.resolve();
    if (leafletP) return leafletP;
    var a = mapBtn ? mapBtn.dataset : {};
    if (a.leafletCss && !D.querySelector('link[data-rm-leaflet]')) {
        var l = D.createElement('link');
        l.rel = 'stylesheet'; l.href = a.leafletCss; l.setAttribute('data-rm-leaflet', '');
        D.head.appendChild(l);
    }
    var vs = W.__vendorScript;
    if (typeof vs !== 'function') return Promise.reject(new Error('no vendor loader'));
    leafletP = vs([a.leafletJs, a.leafletJsFb], { expect: 'L', label: 'leaflet' })
        .then(function () { return vs([a.tilesJs, a.tilesJsFb], { expect: '__mapTiles', label: 'map-tiles' }); })
        .catch(function (e) { leafletP = null; throw e; });
    return leafletP;
}
function makeMap(el) {
    var m = W.L.map(el, { zoomControl: true, attributionControl: true, worldCopyJump: true, scrollWheelZoom: false });
    W.__mapTiles.base(W.L, m, null, { slug: SLUG, style: 'auto', control: false, opts: { maxZoom: 18 } });
    return m;
}
function pin(m, it, i) {
    var g = it.report.gps;
    var mk = W.L.circleMarker([g.lat, g.lon], { radius: 8, weight: 2, color: '#fff', fillColor: '#ef4444', fillOpacity: 0.9 });
    mk.bindTooltip(it.name, { direction: 'top' });
    if (i != null) mk.on('click', function () { select(i, true); });
    return mk.addTo(m);
}
function gpsItems() {
    var out = [];
    S.items.forEach(function (it, i) { if (it.report && it.report.gps) out.push({ it: it, i: i }); });
    return out;
}
function renderMapBtn() {
    if (!mapBtn) return;
    var n = gpsItems().length;
    mapBtn.hidden = n < 1 || S.items.length < 2;
    mapBtn.textContent = fill(t('map_btn', 'On the map (:n)'), { n: n });
    if (mapBtn.hidden) { var w = $('rmMapWrap'); if (w) w.hidden = true; mapBtn.setAttribute('aria-expanded', 'false'); }
}
function drawBatch() {
    var pts = gpsItems();
    if (!batchMap) batchMap = makeMap($('rmMap'));
    if (batchLayer) batchLayer.remove();
    batchLayer = W.L.layerGroup().addTo(batchMap);
    pts.forEach(function (p) { pin(batchLayer, p.it, p.i); });
    setTimeout(function () {
        batchMap.invalidateSize();
        if (pts.length === 1) batchMap.setView([pts[0].it.report.gps.lat, pts[0].it.report.gps.lon], 14);
        else batchMap.fitBounds(pts.map(function (p) { return [p.it.report.gps.lat, p.it.report.gps.lon]; }), { padding: [24, 24], maxZoom: 15 });
    }, 30);
}
if (mapBtn) mapBtn.addEventListener('click', function () {
    var wrap = $('rmMapWrap');
    var open = wrap.hidden;
    wrap.hidden = !open;
    mapBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) return;
    mapBtn.disabled = true;
    ensureLeaflet().then(function () { drawBatch(); ae('map_batch', { n: gpsItems().length }); }, function (err) {
        aeErr('map', err);
        wrap.hidden = true;
        toast(t('map_failed', 'The map did not load.'), 'warning');
    }).then(function () { mapBtn.disabled = false; });
});
function miniMap(btn) {
    var it = S.items[S.sel];
    if (!it || !it.report.gps) return;
    var row = btn.closest('.rm-fv');
    if (row.querySelector('.rm-minimap')) return;
    var el = D.createElement('div');
    el.className = 'rm-minimap';
    row.appendChild(el);
    btn.hidden = true;
    ensureLeaflet().then(function () {
        var m = makeMap(el), g = it.report.gps;
        pin(m, it, null);
        m.setView([g.lat, g.lon], 15);
        setTimeout(function () { m.invalidateSize(); }, 30);
        ae('map_single');
    }, function (err) {
        aeErr('map', err);
        el.remove(); btn.hidden = false;
        toast(t('map_failed', 'The map did not load.'), 'warning');
    });
}

function value(it, k) {
    var r = it.report, f = findings(it, k), M = MS();
    switch (k) {
        case 'gps':
            if (r.gps) {
                // Coordinates keep the dot whatever the locale: «55,75397, 37,62084» reads as four numbers.
                var s = r.gps.lat.toFixed(5) + ', ' + r.gps.lon.toFixed(5);
                if (r.gps.alt != null && isFinite(r.gps.alt)) s += ' · ' + fill(t('alt_m', ':n m'), { n: Math.round(r.gps.alt) });
                return esc(s) + '<br>' + mapLink(r.gps) +
                    '<button type="button" class="rm-maplink" data-rm-minimap>' + esc(t('map_here', 'Show here')) + '</button>' + approxLine(it);
            }
            var tr = f.filter(function (x) { return x.label === 'track'; })[0];
            if (tr) return esc(fill(t('v_gps_track', 'a GPS track (:codec) recorded along the clip'), { codec: tr.detail }));
            return esc(t('v_present', 'recorded in the file'));
        case 'datetime':
            return esc(fmtDate(first(f, ['DateTimeOriginal', 'DateTime', 'creationdate', '©day', 'mvhd', 'tkhd', 'mdhd', 'Timestamp'])) || t('v_present', 'recorded in the file'));
        case 'camera': {
            var cam = first(f, ['Camera']) || [first(f, ['make']), first(f, ['model'])].filter(Boolean).join(' ') || first(f, ['©mak', '©mod']);
            var lens = first(f, ['LensModel', 'camera.lens_model']);
            var sw = first(f, ['Software', 'software', '©swr', '©too']);
            var out = [cam, lens].filter(Boolean).map(esc);
            if (sw) out.push(esc(fill(t('v_software', 'software :v'), { v: sw })));
            return out.join(' · ') || esc(t('v_present', 'recorded in the file'));
        }
        case 'serial': {
            var vals = [];
            f.forEach(function (x) {
                if (x.label === 'MakerNote') vals.push(fill(t('v_makernote', 'maker’s private block · :size'), { size: x.detail }));
                else if (x.detail && !/^\d+ B$/.test(x.detail)) vals.push(x.detail);
            });
            return esc(vals.slice(0, 3).join(' · ') || t('v_present', 'recorded in the file'));
        }
        case 'person': {
            var pv = [];
            f.forEach(function (x) { if (x.detail) pv.push('«' + x.detail + '»'); else if (/XMP|IPTC/.test(x.label)) pv.push(x.label); });
            return esc(pv.slice(0, 4).join(' · ') || t('v_present', 'recorded in the file'));
        }
        case 'copyright': return esc(first(f, ['Copyright', '©cpy', 'cprt', 'copyright']) || t('v_present', 'recorded in the file'));
        case 'thumbnail':
            return esc(t('v_thumb', 'A small copy of the picture hidden inside the file')) +
                (it.exifThumb ? '<img alt="" src="' + it.exifThumb + '">' : '');
        case 'c2pa': return esc(t('v_c2pa', 'signed record of how the file was made and edited'));
        case 'hidden': {
            var hv = [];
            f.forEach(function (x) {
                if (/Motion Photo|Hidden video/i.test(x.label)) hv.push(fill(t('v_hidden_video', 'a video clip with sound · :size'), { size: size(r.hiddenBytes) }));
                else if (/MPF/.test(x.label)) hv.push(t('v_hidden_mpf', 'extra full-size frames (MPF)'));
                else if (x.label === 'track') hv.push(fill(t('v_track', 'a data track (:codec)'), { codec: x.detail }));
                else if (x.label === 'trailer') hv.push(fill(t('v_trailer', 'data after the end of the video · :size'), { size: x.detail }));
                else if (/appended/i.test(x.label)) hv.push(fill(t('v_hidden_data', 'data after the end of the picture · :size'), { size: size(r.hiddenBytes) }));
            });
            return esc(hv.join(' · ') || t('v_present', 'recorded in the file'));
        }
        case 'settings': {
            var sh = M && M.shot ? M.shot(r) : {}, sv = [];
            if (sh.iso) sv.push('ISO ' + sh.iso);
            if (sh.f) sv.push('f/' + num(sh.f, 1));
            if (sh.exposure) sv.push(sh.exposure.replace(' s', ' ' + t('u_s', 's')));
            if (sh.focal) sv.push(fill(t('v_focal', ':n mm'), { n: num(sh.focal, 1) }));
            return esc(sv.join(' · ') || t('v_present', 'recorded in the file'));
        }
        default:
            return esc(f.map(function (x) { return x.label; }).slice(0, 6).join(', ') || t('v_present', 'recorded in the file'));
    }
}
function tells(it) {
    var k = ORDER.filter(function (c) { return it.report.classes[c] && c !== 'other' && c !== 'settings'; });
    if (!k.length) return '';
    var key = it.kind === 'video' ? 'tells_video' : 'tells_photo';
    return fill(t(key, 'This file tells: :list.'), { list: listJoin(k.map(function (c) { return t('tell_' + c, c); })) });
}
function renderDetail() {
    var det = $('rmDetail');
    if (!det) return;
    var it = S.items[S.sel];
    if (!it) {
        det.innerHTML = '<div class="rm-empty">' + svg('pick') + '<span>' + esc(t('detail_empty', 'Pick a file to see what it tells about you.')) + '</span></div>';
        placeDetail();
        return;
    }
    var keep = currentKeep(), r = it.report, cls = ORDER.filter(function (k) { return r.classes[k]; });
    var tellsText = tells(it);
    var head = '<div class="rm-dh">' + thumbHtml(it) +
        '<div><div class="rm-dn" dir="auto">' + esc(it.res ? it.res.outName : it.name) + '</div><div class="rm-ds">' + esc(sub(it)) + '</div></div>' +
        (S.done || S.busy ? '' : '<button type="button" class="rm-x" data-rm-del="' + S.sel + '" aria-label="' + esc(t('remove_file', 'Remove from the list')) + '" title="' + esc(t('remove_file', 'Remove from the list')) + '">' + svg('x') + '</button>') +
        '</div>';
    var verdict = '';
    if (it.res) {
        verdict = '<div class="rm-tells ' + (it.res.clean ? 'is-ok' : '') + '">' + esc(it.res.clean
            ? t('tells_after_ok', 'Checked after cleaning: everything you chose to remove is gone.')
            : fill(t('tells_after_bad', 'Still in the file after cleaning: :list.'), { list: it.res.leftovers.map(function (c) { return t('c_' + c, c); }).join(', ') })) + '</div>';
    } else if (tellsText) {
        verdict = '<div class="rm-tells">' + esc(tellsText) + '</div>';
    } else {
        verdict = '<div class="rm-tells is-ok">' + esc(t('tells_clean', 'No metadata found — this file is already clean.')) + '</div>';
    }
    var rows = cls.map(function (k) {
        var st;
        var rounded = k === 'gps' && (it.res ? !!(it.res.report.gpsApprox && it.res.ap) : !keep.gps && gpsLevel() !== 'off' && !!r.gps);
        if (rounded) st = '<span class="rm-st" data-s="approx">' + esc(t(it.res ? 'st_rounded' : 'st_round', it.res ? 'rounded' : 'round')) + '</span>';
        else if (it.res) st = it.res.removedSet[k] ? '<span class="rm-st" data-s="gone">' + esc(t('st_gone', 'removed')) + '</span>' : '<span class="rm-st">' + esc(t('st_kept', 'kept')) + '</span>';
        else st = keep[k] ? '<span class="rm-st">' + esc(t('st_keep', 'keep')) + '</span>' : '<span class="rm-st" data-s="go">' + esc(t('st_go', 'remove')) + '</span>';
        return '<li class="rm-f" data-tone="' + (TONE[k] || '') + '">' + svg(k) +
            '<div><div class="rm-fl">' + esc(t('c_' + k, k)) + '</div><div class="rm-fv">' + value(it, k) + '</div>' +
            '<div class="rm-fd">' + esc(t('d_' + k, '')) + '</div></div>' + st + '</li>';
    }).join('');
    var raw = '';
    var fs = (r.findings || []).filter(function (f) { return f.cls !== 'icc'; });
    if (fs.length) {
        raw = '<details class="tc-drawer rm-raw"><summary>' + esc(fill(t('raw_title', 'All fields (:n)'), { n: fs.length })) + '</summary><div class="tc-drawer-body"><table>' +
            fs.map(function (f) { return '<tr><td>' + esc(f.label) + '</td><td dir="auto">' + esc(f.detail || '—') + '</td></tr>'; }).join('') +
            '</table></div></details>';
    }
    var notes = [];
    if (it.kind === 'video' && r.warnings && r.warnings.indexOf('video_track_kept_fragmented') !== -1) notes.push(t('w_fragmented', ''));
    if (r.orientationPreserved > 1 || (it.res && it.res.report.orientationPreserved > 1)) notes.push(t('ori_kept', 'The rotation tag is kept, so a portrait photo stays upright.'));
    // Ultra HDR: say what happens to the brightness map, before and after.
    if (r.hdr) {
        var hdrOn = it.res ? !!it.res.report.hdrPreserved : !($('rmKeepHdr') && !$('rmKeepHdr').checked);
        notes.push(t(hdrOn ? 'hdr_kept' : 'hdr_dropped', ''));
    }
    var save = it.res ? '<div class="rm-dsave"><button type="button" class="tc-btn ghost" data-rm-dl="' + S.sel + '">' + esc(t('save', 'Download this file')) + '</button></div>' : '';
    det.innerHTML = head + verdict + (rows ? '<ul class="rm-facts">' + rows + '</ul>' : '') + raw +
        (notes.length ? '<p class="rm-dnote">' + notes.map(esc).join(' ') + '</p>' : '') + save;
    placeDetail();
}
if ($('rmDetail')) $('rmDetail').addEventListener('click', function (e) {
    var del = e.target.closest && e.target.closest('[data-rm-del]');
    if (del) { removeAt(parseInt(del.getAttribute('data-rm-del'), 10)); return; }
    var mm = e.target.closest && e.target.closest('[data-rm-minimap]');
    if (mm) { miniMap(mm); return; }
    var dl = e.target.closest && e.target.closest('[data-rm-dl]');
    if (dl) { var it = S.items[parseInt(dl.getAttribute('data-rm-dl'), 10)]; if (it && it.res) saveOne(it); }
});
function removeAt(i) {
    if (isNaN(i) || !S.items[i] || S.busy) return;
    S.items.splice(i, 1);
    if (S.sel >= S.items.length) S.sel = S.items.length - 1;
    if (!S.items.length) S.sel = -1;
    render(false);
    precheck();
    ae('remove_file');
}

/* ── layout: one screen ─────────────────────────────────────────────────── */
function wideLayout() { return app.clientWidth >= 1100; }
function topBand() {
    var y = 0;
    D.querySelectorAll('header, .site-header, .top-banner, .promo-bar, [class*="banner"]').forEach(function (e) {
        var cs = getComputedStyle(e);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var b = e.getBoundingClientRect();
        if (b.top <= 2 && b.height > 0 && b.height < innerHeight * 0.35 && b.width > innerWidth * 0.5) y = Math.max(y, b.bottom);
    });
    return y;
}
function placeDetail() {
    var det = $('rmDetail'), list = $('rmFiles'), work = $('rmWork');
    if (!det || !list || !work) return;
    var single = S.items.length === 1;
    if (single || wideLayout()) {
        if (det.parentNode !== work) work.appendChild(det);
        det.hidden = false;
        return;
    }
    // Narrow with several files: the dossier opens under the chosen card.
    var card = list.querySelector('.rm-card[aria-selected="true"]');
    if (card) {
        if (card.nextSibling !== det) list.insertBefore(det, card.nextSibling);
        det.hidden = false;
    } else {
        if (det.parentNode !== work) work.appendChild(det);
        det.hidden = true;
    }
}
function layout() {
    var intake = $('rmIntake');
    var h = innerHeight - topBand() - (intake ? intake.getBoundingClientRect().height + 12 : 0) - 20;
    app.style.setProperty('--rm-h', Math.max(420, Math.round(h)) + 'px');
    placeDetail();
}
var lastW = 0;
if (typeof ResizeObserver === 'function') {
    new ResizeObserver(function () {
        var w = app.clientWidth;
        if (Math.abs(w - lastW) < 2) return;
        lastW = w;
        layout();
    }).observe(app);
}
W.addEventListener('resize', function () { if (S.items.length) layout(); });

/* ══════════════════════════ RUN ══════════════════════════ */
var runBtn = $('rmRunBtn');
if (runBtn) runBtn.addEventListener('click', run);

function outputName(it, rename, i, format) {
    var given = ((/\.([a-z0-9]+)$/i.exec(it.name) || [0, ''])[1]) || '';
    // Name by what the bytes ARE: messengers rename a PNG to .jpg routinely.
    var M = MS();
    var ext = M && M.canonicalExt ? M.canonicalExt(format, given) : (given || 'jpg').toLowerCase();
    // A filename is metadata too: IMG_20240612_143022.jpg states the minute.
    if (rename) return (it.kind === 'video' ? 'video_' : 'image_') + String(i + 1).padStart(4, '0') + '.' + ext;
    return it.name.replace(/\.[^.]+$/, '') + '_clean.' + ext;
}
function leftoversOf(rep, keep, ap) {
    return Object.keys(rep.classes).filter(function (c) {
        if (c === 'icc' || c === 'settings' || keep[c]) return false;
        // A rounded location is a location on purpose — if it is the chosen one.
        return !(c === 'gps' && ap && approxHolds(rep, ap));
    });
}

function run() {
    if (S.busy || !S.items.length) return;
    var M = MS();
    if (!M) { toast(t('err_engine', 'The cleaning engine failed to load. Please reload the page.'), 'error'); return; }
    var real = S.items.filter(function (x) { return !x.sample; });
    // begin() is the RESERVATION: it refuses a queue bigger than the remainder
    // without spending anything. What is billed is decided at the end, from
    // the files that really produced a result. Our examples are never billed.
    var _run = null;
    if (W.__toolLimit && real.length) {
        _run = W.__toolLimit.begin(SLUG, W.__toolLimit.fileKeys ? W.__toolLimit.fileKeys(real.map(function (x) { return x.file; })) : null);
        if (!_run) return;                        // the wall is already shown
    }
    S.busy = true;
    runBtn.disabled = true;
    var prog = $('rmProgress');
    if (prog) { prog.hidden = false; prog.firstElementChild.style.width = '0%'; }
    stage('process');
    renderClasses();
    var keep = currentKeep();
    var keepOri = !!($('rmKeepOri') && $('rmKeepOri').checked);
    var keepHdr = !($('rmKeepHdr') && !$('rmKeepHdr').checked);
    var rename = !!($('rmRename') && $('rmRename').checked);
    var t0 = W.performance ? performance.now() : Date.now();
    var failed = 0, idx = 0, n = S.items.length;

    function one(it, i) {
        it._ap = approxFor(it, keep);
        if (it.kind === 'video') {
            var src = fileReader(it.file);
            return M.scrubVideo(src, { keep: keep, name: it.name, gpsApprox: it._ap }).then(function (rec) {
                // Self-check on the recipe itself, before a byte is written.
                return M.inspectVideo(M.partsReader(rec.parts, src), it.name).then(function (v) {
                    var parts = rec.parts.map(function (p) {
                        if (p instanceof Uint8Array) return p;
                        if (p.zero != null) return new Uint8Array(p.zero);
                        return it.file.slice(p.from, p.to);
                    });
                    return finishOne(it, i, rec.report, v, new Blob(parts, { type: mimeOf(rec.report.format) }), rec.size);
                });
            });
        }
        return it.file.arrayBuffer().then(function (buf) {
            // `probe` hands back the intake inspection: two walks per file, not four.
            var out = M.scrub(new Uint8Array(buf), { keep: keep, keepOrientation: keepOri, keepHdr: keepHdr, gpsApprox: it._ap, name: it.name, probe: it.report });
            // ── SELF-VERIFICATION — a cleaner that cannot prove its output is a promise.
            var v = window.MetaScrub.inspect(out.bytes, it.name);
            return finishOne(it, i, out.report, v, new Blob([out.bytes], { type: mimeOf(out.report.format) }), out.bytes.length);
        });
    }
    function finishOne(it, i, rep, verify, blob, outSize) {
        var leftovers = leftoversOf(verify, keep, it._ap);
        var removedSet = {};
        (rep.removed || []).forEach(function (c) { removedSet[c] = 1; });
        it.res = {
            ap: rep.gpsApprox ? it._ap : null,
            blob: blob, size: outSize, report: rep, clean: leftovers.length === 0, leftovers: leftovers,
            removedSet: removedSet, outName: outputName(it, rename, i, rep.format),
        };
    }
    function step() {
        if (idx >= n) return Promise.resolve();
        var it = S.items[idx], i = idx++;
        it.res = null;
        return one(it, i).catch(function (err) {
            aeErr('scrub', err, { fmt: it.format, kind: it.kind });
            failed++;
        }).then(function () {
            if (prog) prog.firstElementChild.style.width = Math.round(idx / n * 100) + '%';
            return yieldUI();
        }).then(step);
    }
    // «City»: every point must have its city before the first byte is written.
    var ready = (gpsLevel() === 'city' && !keep.gps) ? placeAll() : Promise.resolve();
    ready.then(step).then(function () {
        S.busy = false;
        runBtn.disabled = false;
        if (prog) prog.hidden = true;
        var done = S.items.filter(function (x) { return x.res; });
        // Billing: release the reservation, charge only files that produced a result.
        if (_run) {
            _run.abort();
            var billed = done.filter(function (x) { return !x.sample; }).map(function (x) { return x.file; });
            if (billed.length && W.__toolLimit) {
                var keys = W.__toolLimit.fileKeys(billed);
                if (keys.length) W.__toolLimit.record(SLUG, keys);
                if (W.__toolLimit.refresh) W.__toolLimit.refresh(SLUG);
            }
        }
        if (!done.length) {
            toast(t('err_all_failed', 'None of the files could be processed.'), 'error');
            renderClasses();
            return;
        }
        if (failed) toast(fill(t('err_some_failed', ':n file(s) could not be processed.'), { n: failed }), 'warning');
        S.done = true;
        render(true);
        stage('done');
        runTelemetry(done, failed, keep, keepOri, rename, (W.performance ? performance.now() : Date.now()) - t0);
    });
}
function runTelemetry(done, failed, keep, keepOri, rename, ms) {
    var removed = {}, saved = 0, notClean = [];
    done.forEach(function (x) {
        (x.res.report.removed || []).forEach(function (c) { removed[c] = (removed[c] || 0) + 1; });
        saved += Math.max(0, x.size - x.res.size);
        if (!x.res.clean) notClean.push(x);
    });
    var payload = {
        n: done.length, failed: failed, mode: S.mode, ms: Math.round(ms),
        removed: Object.keys(removed).sort().join(','), saved_kb: Math.round(saved / 1024),
        video_n: done.filter(function (x) { return x.kind === 'video'; }).length,
        gps_level: gpsLevel(), rounded_n: done.filter(function (x) { return x.res.ap; }).length,
    };
    try { if (W.__aeToolComplete) W.__aeToolComplete(Object.assign({ slug: SLUG, files: done.length }, payload)); } catch (e) {}
    ae('scrub_done', Object.assign({ keep_ori: keepOri ? 1 : 0, rename: rename ? 1 : 0 }, payload));
    // The central claim is «we checked, nothing is left». If that ever fails
    // in the wild it must page us, not sit silently on a screen.
    if (notClean.length) {
        try {
            if (W.__aeCritical) W.__aeCritical('verify_leftover', {
                slug: SLUG, n: notClean.length, total: done.length,
                cls: notClean.reduce(function (a, x) { return a.concat(x.res.leftovers); }, []).slice(0, 8).join(','),
                fmt: notClean.map(function (x) { return x.format; }).slice(0, 8).join(','),
            });
        } catch (e) {}
    }
}

/* ══════════════════════════ RESULT ══════════════════════════ */
function delivered() { return S.items.filter(function (x) { return x.res; }); }
function renderResult() {
    var done = delivered();
    var bad = done.filter(function (x) { return !x.res.clean; });
    var saved = done.reduce(function (a, x) { return a + Math.max(0, x.size - x.res.size); }, 0);
    var v = $('rmVerify');
    v.className = 'rm-verdict' + (bad.length ? ' is-bad' : '');
    v.innerHTML = svg(bad.length ? 'bad' : 'ok') + '<div><b>' + esc(bad.length
        ? fill(tn('verify_bad', bad.length, ':n file(s) still carry something that could not be removed.'), { n: bad.length })
        : fill(tn('verify_ok', done.length, 'Checked after cleaning: nothing you chose is left in :n file(s).'), { n: done.length })) +
        '</b><span>' + esc(fill(t('verify_sub', ':size of metadata removed · the picture and sound are not re-encoded'), { size: size(saved) })) + '</span></div>';
    var dl = $('rmDownload');
    dl.textContent = done.length > 1 ? fill(t('download_zip', 'Download all (:n) as ZIP'), { n: done.length }) : t('download_one', 'Download the cleaned file');
    var files = shareFiles();
    $('rmShare').hidden = !files;
    $('rmFolder').hidden = !(done.length > 1 && typeof W.showDirectoryPicker === 'function');
    var anyVideo = done.some(function (x) { return x.kind === 'video'; });
    $('rmResNote').textContent = t(anyVideo ? 'result_note_video' : 'result_note',
        'The picture itself is untouched: only metadata bytes were removed, the compressed pixels were copied as they are.');
}
// Web Share with files (Android, iOS, Windows): «clean, then send to the chat»
// without saving first. canShare() does not check size, so we do.
function shareFiles() {
    var done = delivered();
    if (!done.length || done.length > 10 || !navigator.share || !navigator.canShare) return null;
    var total = done.reduce(function (a, x) { return a + x.res.size; }, 0);
    if (total > 200 * 1048576) return null;
    try {
        var files = done.map(function (x) { return new File([x.res.blob], x.res.outName, { type: x.res.blob.type }); });
        return navigator.canShare({ files: files }) ? files : null;
    } catch (e) { return null; }
}
function saveOne(it) {
    if (window.__downloadFile) window.__downloadFile(it.res.blob, it.res.outName);
    ae('download_single', { kind: it.kind });
}
function batchItems() { return delivered().map(function (x) { return { name: x.res.outName, blob: x.res.blob }; }); }
function withBatch() { return W.__batchDeliver ? Promise.resolve(W.__batchDeliver) : W.__ensureBatchDeliver(); }
var dlBtn = $('rmDownload');
if (dlBtn) dlBtn.addEventListener('click', function () {
    var done = delivered();
    if (!done.length) return;
    if (done.length === 1) { saveOne(done[0]); return; }
    dlBtn.disabled = true;
    // Through the batch primitive (STORE, measured ceiling, distinct names):
    // «IMG_1.JPG» + «IMG_1.jpg» both come out «IMG_1_clean.jpg».
    withBatch().then(function (BD) {
        return BD.deliver(batchItems(), { slug: SLUG, zipName: 'clean-files.zip', archiveOnly: true });
    }).then(function (res) {
        if (res && res.via === 'zip') ae('download_zip', { n: done.length });
    }).catch(function (err) {
        aeErr('zip', err);
        toast(t('err_zip', 'Could not build the ZIP — save the files one by one.'), 'error');
    }).then(function () { dlBtn.disabled = false; });
});
var folderBtn = $('rmFolder');
if (folderBtn) folderBtn.addEventListener('click', function () {
    var n = delivered().length;
    folderBtn.disabled = true;
    // deliver() without archiveOnly asks for a folder first (its first await
    // is the picker, so the click's activation is still alive).
    withBatch().then(function (BD) {
        return BD.deliver(batchItems(), { slug: SLUG, zipName: 'clean-files.zip' });
    }).then(function (res) {
        ae('download_folder', { n: n, via: res && res.via });
    }).catch(function (err) { aeErr('folder', err); }).then(function () { folderBtn.disabled = false; });
});
var shareBtn = $('rmShare');
if (shareBtn) shareBtn.addEventListener('click', function () {
    var files = shareFiles();
    if (!files) return;
    navigator.share({ files: files, title: t('share_title', 'Files without metadata') }).then(function () {
        ae('share', { n: files.length });
    }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        aeErr('share', err);
        toast(t('err_share', 'Could not share — download the file instead.'), 'warning');
    });
});
/* Report — the compliance half: proof of what was stripped. */
var repBtn = $('rmReport');
if (repBtn) repBtn.addEventListener('click', function () {
    var done = delivered();
    if (!done.length) return;
    var head = ['file', 'kind', 'format', 'size_before', 'size_after', 'found', 'removed', 'location_left', 'verified_clean'];
    var rows = done.map(function (x) {
        var ap = x.res.ap;
        return [x.name, x.kind, x.res.report.format, x.size, x.res.size, Object.keys(x.report.classes).join(' '),
                (x.res.report.removed || []).filter(function (c) { return !(c === 'gps' && ap); }).join(' '),
                ap ? ap.lat.toFixed(ap.digits) + ' ' + ap.lon.toFixed(ap.digits) + (ap.kind === 'city' ? ' (' + ap.name + ')' : '') : '',
                x.res.clean ? 'yes' : 'no'];
    });
    var csv = [head].concat(rows).map(function (row) {
        return row.map(function (c) { return '"' + String(c).replace(/"/g, '""') + '"'; }).join(',');
    }).join('\r\n');
    // BOM so Excel opens UTF-8 names correctly
    var blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
    if (window.__downloadFile) window.__downloadFile(blob, 'metadata-report.csv');
    ae('report_csv', { n: done.length });
});
function leaveResult() {
    S.done = false;
    S.items.forEach(function (x) { x.res = null; });
}
var backBtn = $('rmBack');
if (backBtn) backBtn.addEventListener('click', function () { leaveResult(); render(true); ae('back_to_setup'); });
function clearAll(why) {
    var n = S.items.length;
    S.items.forEach(function (x) { if (x.exifThumb) { try { URL.revokeObjectURL(x.exifThumb); } catch (e) {} } });
    S.items = []; S.sel = -1; S.done = false;
    render(true);
    precheck();
    ae(why, { n: n });
}
var resetBtn = $('rmReset');
if (resetBtn) resetBtn.addEventListener('click', function () { clearAll('reset'); });
var clearBtn = $('rmClear');
if (clearBtn) clearBtn.addEventListener('click', function () { if (!S.busy) clearAll('clear_all'); });

/* ══════════════════════════ SETTINGS ══════════════════════════ */
// The shared primitive, not hand-rolled localStorage. The layout defines it
// below the content, so a parse-time `if (window.__toolSettings)` would be
// silently false — bind once the document is parsed.
function bindSettings() {
    var TS = W.__toolSettings;
    if (TS) {
        try {
            TS.bind(SLUG, $('rmKeepIcc'), 'keepIcc', true);
            TS.bind(SLUG, $('rmKeepOri'), 'keepOri', true);
            TS.bind(SLUG, $('rmKeepHdr'), 'keepHdr', true);
            TS.bind(SLUG, $('rmRename'), 'rename', false);
        } catch (e) {}
    }
    var m = 'full';
    try { m = TS ? TS.load(SLUG, 'mode', 'full') : 'full'; } catch (e) {}
    // «Custom» comes back with the boxes the person ticked last time.
    if (m === 'custom') {
        try {
            var c = JSON.parse(TS.load(SLUG, 'custom', '') || 'null');
            if (c && typeof c === 'object') S.custom = c; else m = 'full';
        } catch (e) { m = 'full'; }
    }
    try { S.gps = TS ? TS.load(SLUG, 'gpsLevel', 'off') : 'off'; } catch (e) {}
    setMode(m, true);
    renderKeepSub();
}
if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', bindSettings); else bindSettings();
})();
